var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"like-button"},[_c('button',{staticClass:"like-button__button",class:{ 'like-button__button--liked': _vm.liked },on:{"click":function($event){return _vm.toggleLike()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }